module.exports = __webpack_public_path__ + "img/move.e4f81e1e.png";